<script>
import { allowCookies, denyCookies } from '@/api/Cookies'

export default {
  name: 'CookieDialog',
  methods: {
    close() {
      this.$emit('close')
    },
    deny() {
      denyCookies()
      this.$emit('close')
    },
    allow() {
      allowCookies()
      this.$emit('close')
    }
  }
}
</script>

<template>
  <section class="dialog-container">
    <!--    <header class="dialog-header">-->
    <!--      <close-button @click="close()"></close-button>-->
    <!--    </header>-->
    <main class="dialog-main">
      <p>
        Rijnja.nl wil graag cookies plaatsen voor analytische doeleinden.<br />Geeft
        u hiervoor toestemming?
      </p>
      <p>
        Zie ook ons
        <router-link to="/cookiebeleid">Cookiebeleid</router-link>
      </p>
    </main>
    <footer class="dialog-footer">
      <button class="pill-button secondary" @click="deny">
        WEIGEREN
      </button>
      <button class="pill-button" @click="allow">
        TOESTAAN
      </button>
    </footer>
  </section>
</template>

<style scoped lang="scss">
.dialog-container {
  padding: 25px;

  p {
    margin-bottom: 10px;
  }

  .dialog-header {
    padding: 0;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-weight: 600;
  }

  .dialog-main {
    margin-bottom: 10px;

    input {
      width: 100%;
    }

    .link {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .dialog-footer {
    margin-top: 20px;
    padding: 0;
    display: flex;
    justify-content: flex-end;

    button {
      margin-left: 10px;
    }
  }
}
</style>
